"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletLinkAnalytics = void 0;
class WalletLinkAnalytics {
    sendEvent(_eventType, _eventProperties) {
        // no-op
    }
}
exports.WalletLinkAnalytics = WalletLinkAnalytics;
